import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { message, notification } from 'antd';
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import RecaptchaModal from "../../components/recaptcha";
import {
    BASE_URLS,
    getBookingHubOrderLinkDetails,
    addBookingHubOrderChargeById,
    addCheckoutPageChargeById,
    cashfreeAction,
    getCheckoutCardCharges,
    getCheckoutChallanCharges,
    getCheckoutReconnection,
    getQrPaymentReconnection,
    getSecretValuesById,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import {
    MESSAGES,
    NETBANKING_LIST,
    QR_STATUSES,
    REFRENCE_ID_LENGTH,
    SESSION_TIME,
    SWIREPAY_URL,
    TabNames,
    ACQUIRER_TYPE_PAYPAL,
    ACQUIRER_TYPE_PAYPAL_BNY,
} from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "../eventPageDetails/components/smallscreen/header";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/footer";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantAch from "../../components/InstantAch";
import SwiftAch from "../../components/SwiftAch";
import RapidWithPlaid from "../../components/rapidAchWithPlaid";
import ZipAchWithPlaid from "../../components/zipAchWithPlaid";
import XAchWithPlaid from "../../components/xAchWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import ChallanPayment from "../../components/challanpayment/ChallanPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import PayPalCheckout from "../paypalCheckout";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg";
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import ApplePay from "../../components/applePay/ApplePay";
import Apple from '../apple';
import parsePhoneNumberFromString from "libphonenumber-js";
import { formatToE164 } from "../../utils/formatToE164";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import ApplePayButton from '../apple/PayPalApplePay';
import PayPalGooglePay from "../../components/payPalGooglePay";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import UpiPayment from "../../components/upipayment/UpiPayment";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import { setFormData, setIsWaitingForUpiApp, setUserReturnedFromUpiApp } from "../../redux/appConfigInfo";
import { Base64 } from "js-base64";

type Props = {
    history: {
        push: Function,
    },
}

const BookingHubOrderPay = (props: Props) => {
    const { match: { params: { bookingHubOrderLinkId } }, location: { pathname, search } } = props;

    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${bookingHubOrderLinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [userType, setUserType] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [supportPhoneNumber, setSupportPhoneNumber] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [applePayment, setApplePayment] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const [net, setNet] = useState(null);
    const [feeService, setFeeService] = useState(null);
    const [finalTax, setFinalTax] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [caluclation, setCaluclation] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [finalTip, setFinalTip] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [subTotalAfterDiscount, setSubTotalAfterDiscount] = useState(null);
    const [serviceFeeVal, setServiceFeeVal] = useState(null);
    const [serviceFeeRateVal, setServiceFeeRateVal] = useState(null);
    const [finalAmount, SetFinalAmount] = useState(null);
    const [finalTaxValue, setTaxValue] = useState(null);
    const [taxPercentage, setTaxPercentage] = useState(null);
    const [surcharge, setSurcharge] = useState(null);
    const [serviceFeeRate, setServiceFeeRate] = useState(false);
    const [serviceFee, setServiceFee] = useState(false);
    const [updatedCardNum, setUpdatedCardNum] = useState('');
    const [optionalCheck, setOptionalCheck] = useState(true);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkGlobalRecaptcha, setPaymentLinkGlobalRecaptcha] = useState(null);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const accountGid = [
        'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${bookingHubOrderLinkId}`) || undefined);
    const { isWaitingForUpiApp, userReturnedFromUpiApp } = useSelector((state) => state.appConfigInfo);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const paymentSessionGidRef = useRef(null);
    const upiAppPsClientSecretRef = useRef(null);
    const redirectUrlRef = useRef(null);
    const inflightActionRef = useRef(null);
    const upiIndentCheckStatus = useRef('');
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const paypalPaymentData = useRef(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };
    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    };

    useEffect(() => {
        const acquirer = payment?.account?.acquirer;
        if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    useEffect(() => {
        if (updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails) {
            if (updateCustomerRedux?.customerDetails?.name && updateCustomerRedux?.customerDetails?.name !== '') {
                setPayment((prev) => ({ ...prev, bookingHubOrder: { ...prev?.bookingHubOrder, customer: { ...prev?.bookingHubOrder?.customer, name: updateCustomerRedux.customerDetails.name } } }));
            }
            if (updateCustomerRedux?.customerDetails?.email && updateCustomerRedux?.customerDetails?.email !== '') {
                setPayment((prev) => ({ ...prev, bookingHubOrder: { ...prev?.bookingHubOrder, customer: { ...prev?.bookingHubOrder?.customer, email: updateCustomerRedux.customerDetails.email } } }));
            }
            if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined' && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1') {
                setPayment((prev) => ({ ...prev, bookingHubOrder: { ...prev?.bookingHubOrder, customer: { ...prev?.bookingHubOrder?.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } } }));
            }
            dispatch(setUpdateStatus(false));
        }
    }, [updateCustomerRedux]);

    useState(() => {
        if (window.ApplePaySession) {
            setIsApplePay(true);
        }
    }, []);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    };

    const setPaymentOrder = (account) => {
        if (account.supportedPaymentTypes) {
            let paymentOrder = getUniquePaymentTypes(account.supportedPaymentTypes);
            if (account.paymentTypeOrder) {
                paymentOrder = [
                    ...account.paymentTypeOrder
                        .map((paymentType1) => {
                            const found = paymentOrder.find((paymentType) => paymentType.category === paymentType1.category);
                            return found ? { category: found } : null;
                        })
                        .filter(Boolean),
                    ...paymentOrder
                        .filter((paymentType) =>
                            !account.paymentTypeOrder.some((paymentType1) => paymentType.category === paymentType1.category)
                        )
                        .map((paymentType) => ({ category: paymentType }))
                ];
            }
            setPaymentTypeOrder(paymentOrder);
        } else {
            setPaymentTypeOrder([{ category: 'CARD' }]);
        }
    };

    useEffect(() => {
        if (payment?.account) {
            const { account, bookingHubOrder } = payment;
            if (account.currency && bookingHubOrder?.total) {
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(bookingHubOrder.total), account.currency.name)}`);
                setTotalAmount(currencyFormatter(AmountDivideByHundred(bookingHubOrder.total), account.currency.name));
            }
            setSupportedPaymentTypes(account.supportedPaymentTypes);
            setApplePayment(account.supportedPaymentTypes?.includes('APPLE_PAY_US'));
            setSwirepayUS(account.supportedPaymentTypes?.includes('SWIREPAY_US'));
            setGooglePayUs(account.supportedPaymentTypes?.includes('GOOGLE_PAY_US'));
            setPaymentOrder(account);
            setSupportPhoneNumber(payment?.support?.phone);
        }
    }, [payment]);

    const getGooglePayMerchantValues = async (accountGid, isTest) => {
        try {
            const values = await getSecretValuesById(accountGid, isTest);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support');
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message: msg, messageCode }, status } = reason;
        setErrorMessage(msg);
        if (status === 500) {
            setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
        }
        resetAlertConfig();
        setTransactionModalOpen(false);
        const errorEl = document.getElementById("error");
        if (null !== errorEl) {
            errorEl.scrollIntoView();
        }
    };

    useEffect(() => {
        getOrderData();
    }, [bookingHubOrderLinkId]);

    const getOrderData = async () => {
        setShowSpinner(true);
        try {
            const value = await getBookingHubOrderLinkDetails(bookingHubOrderLinkId);
            if (value) {
                if (value.bookingHubOrder?.paymentStatus !== 'UN_PAID') {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                value.currency = value?.account?.currency;
                value.amount = value?.bookingHubOrder?.total;
                setPayment(value);

                // Extract customer info from order labels
                const labelFields = {};
                value?.bookingHubOrder?.bookingHubOrderLabels?.forEach(labelItem => {
                    if (labelItem?.dataType === 'INPUT_PHONE') {
                        const phoneNumber = parsePhoneNumberFromString(labelItem?.value);
                        labelFields.countryCallingCode = phoneNumber?.countryCallingCode || '1';
                        labelFields.phone = phoneNumber?.nationalNumber;
                    }
                    if (labelItem?.dataType === 'INPUT_EMAIL') {
                        labelFields.email = labelItem?.value;
                    }
                    if (labelItem?.dataType === 'INPUT_NAME' && !labelFields.name) {
                        labelFields.name = labelItem?.value;
                    }
                });

                const customerPhone = getCountryCodeAndNumber(value?.bookingHubOrder?.customer?.phoneNumber);
                dispatch(setFormData({
                    code: 'CUSTOMER_DETAIL',
                    value: {
                        phoneNumber: labelFields?.phone || customerPhone?.phoneNumber,
                        countryCode: labelFields?.countryCallingCode ? `+${labelFields?.countryCallingCode}` : customerPhone?.countryCode,
                        name: value?.bookingHubOrder?.customer?.name || labelFields?.name,
                        email: value?.bookingHubOrder?.customer?.email || labelFields?.email,
                        disablePhone: false,
                    }
                }));

                if (value.account?.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account?.bankImageUrl);
                    setPartnerImageUrl(value.account?.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        setBanksList(NETBANKING_LIST.filter(data => data.isTest === true));
                    } else {
                        setBanksList(NETBANKING_LIST.filter(data => data.isTest === false));
                    }
                }

                if (value.account?.supportedPaymentTypes?.includes('GOOGLE_PAY_US')) {
                    getGooglePayMerchantValues(value.account?.gid, value?.account?.portal?.test);
                }
                if (value.account?.supportedPaymentTypes?.includes('APPLE_PAY_US') || value.account?.supportedPaymentTypes?.includes('WALLET')) {
                    getGooglePayMerchantValues(value.account?.gid, value?.account?.portal?.test);
                }

                setUserType(value.account?.mdr);
            }
        } catch (e) {
            console.error('Error fetching booking hub order link:', e);
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false);
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment?.bookingHubOrder?.customer?.gid;
    };

    const customerInfo = useMemo(() => {
        if (payment?.bookingHubOrder?.customer) {
            return payment.bookingHubOrder.customer;
        }
        const info = {};
        const labels = payment?.bookingHubOrder?.bookingHubOrderLabels;
        if (Array.isArray(labels) && labels.length > 0) {
            labels.forEach(label => {
                switch (label?.dataType) {
                    case 'INPUT_PHONE':
                        info.phoneNumber = label?.value;
                        break;
                    case 'INPUT_EMAIL':
                        info.email = label?.value;
                        break;
                    case 'INPUT_NAME':
                        if (!info.name) info.name = label?.value;
                        break;
                    default:
                }
            });
            return info;
        }
        return null;
    }, [payment]);

    const clearBookingHubSession = () => {
        Object.keys(sessionStorage).forEach((key) => {
            if (key.startsWith('bh-') || key === 'seatsio') {
                sessionStorage.removeItem(key);
            }
        });
    };

    const chargeByIdSuccessActions = async (value) => {
        let nextActionUrl = value?.nextActionUrl || value?.paymentSession?.nextActionUrl;
        let redirectUrl = value?.redirectUrl || value?.paymentSession?.redirectUrl;
        let returnUrl = value?.returnUrl || value?.paymentSession?.returnUrl;

        if (!nextActionUrl) {
            try {
                const info = await getBookingHubOrderLinkDetails(bookingHubOrderLinkId);
                nextActionUrl = info?.nextActionUrl || info?.paymentSession?.nextActionUrl;
                redirectUrl = redirectUrl || info?.redirectUrl;
            } catch (e) {}
        }
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }

        if (value?.paymentSession?.status === 'REQUIRE_CONFIRMATION') {
            setManualPlaidPayment(true);
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        const timeOut = value?.paymentSession?.status === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID : 10000;
        setTimeout(() => {
            clearBookingHubSession();
            let finalRedirectUrl = returnUrl || redirectUrl || (payment?.bookingHubOrder?.bookingHubGid
                ? `${SWIREPAY_URL}/booking-hub/${payment?.bookingHubOrder?.bookingHubGid}`
                : SWIREPAY_URL);

            const orderGid = payment?.bookingHubOrder?.gid || bookingHubOrderLinkId;
            if (orderGid && finalRedirectUrl) {
                const separator = finalRedirectUrl.includes('?') ? '&' : '?';
                finalRedirectUrl = `${finalRedirectUrl}${separator}sp-booking-hub-order=${orderGid}`;
            }
            window.location = finalRedirectUrl;
        }, timeOut);
        if (bookingHubOrderLinkId) {
            localStorage.removeItem(`${bookingHubOrderLinkId}-tap-index`);
            localStorage.removeItem(`${bookingHubOrderLinkId}-tab-name`);
        }
    };

    const addCheckoutPageById = async (data, recaptchaToken = null) => {
        data.surchargeApplicable = payment?.account?.surchargeType === 'OPTIONAL'
            ? optionalCheck : (payment?.account?.surchargeType !== 'NONE')
                ? true : false;
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addBookingHubOrderChargeById(bookingHubOrderLinkId, payload);
                        if (value) {
                            if (!isPayPalApple.current && !isPayPalGoogle.current) {
                                await chargeByIdSuccessActions(value);
                            }
                            return value;
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const chargeByCard = async (data) => {
        const { paymentMethod, customer, notify } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        if (customer.Address) {
            delete customer.Address;
        }
        await addCheckoutPageById({ paymentMethod, customer, shouldWhatsAppNotify: notify });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await addCheckoutPageById({ customer, paymentMethod, customerGid: getCustomerGidFromPayment() });
    };

    const chargeByNetBanking = async (data) => {
        const { gid } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: { swirepayBankGid: gid },
        };
        await addCheckoutPageById({ paymentMethod, customerGid: getCustomerGidFromPayment() });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: { alias: walletAlias, type: "ALIAS" },
        };
        await addCheckoutPageById({ paymentMethod, customerGid: getCustomerGidFromPayment() });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: { alias: walletAlias, type: "ALIAS" },
        };
        await addCheckoutPageById({ paymentMethod, customerGid: getCustomerGidFromPayment() });
    };

    const chargeByUpi = async (data) => {
        const { paymentMethod } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        await addCheckoutPageById({
            paymentMethod,
        });
    };

    const generateChallan = async (data) => {
        await addCheckoutPageById(data);
    };

    const getPaymentCharges = async (cardNumber, payments) => {
        try {
            let value = null;
            if (null != cardNumber) {
                value = await getCheckoutCardCharges(bookingHubOrderLinkId, cardNumber);
            } else {
                value = await getCheckoutChallanCharges(bookingHubOrderLinkId);
            }
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred((payments?.bookingHubOrder?.total || 0) + value.feeAmount + value.taxAmount), payments?.account?.currency?.name)}`);
                setTotalAmount(currencyFormatter(AmountDivideByHundred((payments?.bookingHubOrder?.total || 0) + value.feeAmount + value.taxAmount), payments?.account?.currency?.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payments?.bookingHubOrder?.total || 0), payments?.account?.currency?.name));
        } finally {
            setShowSpinner(false);
        }
    };

    const chargeByUpiIndent = async (data, recaptchaToken = null) => {
        const payaloadData = {
            paymentMethod: data?.paymentMethod,
            customerGid: getCustomerGidFromPayment(),
            surchargeApplicable: payment?.account?.surchargeType === 'OPTIONAL'
                ? optionalCheck : (payment?.account?.surchargeType !== 'NONE')
                    ? true : false,
        };
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(payaloadData), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addBookingHubOrderChargeById(bookingHubOrderLinkId, payload);
                        if (value) {
                            const { nextActionUrl, redirectUri } = value;
                            paymentSessionGidRef.current = value?.paymentSession?.gid || value?.paymentSessionGid;
                            upiAppPsClientSecretRef.current = value?.paymentSession?.psClientSecret || value?.psClientSecret;
                            redirectUrlRef.current = redirectUri;
                            return (nextActionUrl || null);
                        }
                    }
                }
            }
            return null;
        } catch (reason) {
            error(reason);
        }
    };

    const handleRedirect = () => {
        clearBookingHubSession();
        const redirectUrl = redirectUrlRef?.current ? redirectUrlRef?.current : SWIREPAY_URL;
        const urlPath = redirectUrl.includes("?");
        if (urlPath) {
            window.location = `${redirectUrl}&sp-booking-hub-order=${bookingHubOrderLinkId}`;
        } else {
            window.location = `${redirectUrl}?sp-booking-hub-order=${bookingHubOrderLinkId}`;
        }
    };

    useEffect(() => {
        if (!isWaitingForUpiApp || userReturnedFromUpiApp) return;

        let cancelled = false;

        const checkUpiStatus = async () => {
            setTransactionModalOpen(true);
            try {
                const paymentSessionId = paymentSessionGidRef?.current;
                const clientSecret = upiAppPsClientSecretRef?.current;
                if (!paymentSessionId || !clientSecret) {
                    error({ data: { message: 'Could not check UPI payment.' } });
                    return;
                }
                let entity;
                let response;
                let attempts = 0;
                const MAX_ATTEMPTS = 30;
                const POLLING_INTERVAL = 10000;
                while (attempts < MAX_ATTEMPTS) {
                    if (cancelled) return;
                    const promise = payment?.account?.acquirer === 'CASHFREE'
                        ? cashfreeAction(paymentSessionId, clientSecret)
                        : action(paymentSessionId, clientSecret);
                    inflightActionRef.current = promise;
                    response = await promise;
                    inflightActionRef.current = null;
                    entity = response?.data?.entity;
                    upiIndentCheckStatus.current = entity?.status;
                    if (entity?.status === 'REQUIRE_ACTION') {
                        await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
                        attempts++;
                    } else {
                        break;
                    }
                }
                if (cancelled) return;
                if (entity?.status === 'REQUIRE_ACTION') {
                    error({ data: { message: 'UPI payment could not be verified at the moment.' } });
                    paymentSessionGidRef.current = null;
                    upiAppPsClientSecretRef.current = null;
                    setTransactionModalOpen(false);
                    dispatch(setIsWaitingForUpiApp(null));
                    dispatch(setUserReturnedFromUpiApp(null));
                    upiIndentCheckStatus.current = '';
                } else if (entity?.status !== 'SUCCEEDED') {
                    error(response?.data?.message ? response : { data: { message: 'UPI Payment Failed' } });
                    paymentSessionGidRef.current = null;
                    upiAppPsClientSecretRef.current = null;
                    setTransactionModalOpen(false);
                    dispatch(setIsWaitingForUpiApp(null));
                    dispatch(setUserReturnedFromUpiApp(null));
                    upiIndentCheckStatus.current = '';
                }
            } catch (e) {
                if (cancelled) return;
                console.error('[long-poll] error:', e);
                error(e);
            }
        };

        checkUpiStatus();
        return () => {
            cancelled = true;
        };
    }, [isWaitingForUpiApp, userReturnedFromUpiApp, error, payment?.account?.acquirer]);

    const onReturnFromUpiApp = async () => {
        setTransactionModalOpen(true);

        if (inflightActionRef.current) {
            const response = await inflightActionRef.current.catch(() => {});
            upiIndentCheckStatus.current = response?.data?.entity?.status;
        }

        try {
            const paymentSessionId = paymentSessionGidRef?.current;
            const clientSecret = upiAppPsClientSecretRef?.current;
            if (!paymentSessionId || !clientSecret) {
                error({ data: { message: 'Could not check UPI payment.' } });
                return;
            }
            let entity;
            let response;
            let attempts = 0;
            const MAX_ATTEMPTS = 15;
            const POLLING_INTERVAL = 1000;
            while (attempts < MAX_ATTEMPTS && (upiIndentCheckStatus.current === 'REQUIRE_ACTION' || !upiIndentCheckStatus.current)) {
                if (payment?.account?.acquirer === 'CASHFREE') {
                    response = await cashfreeAction(paymentSessionId, clientSecret);
                } else {
                    response = await action(paymentSessionId, clientSecret);
                }
                entity = response?.data?.entity;
                if (entity?.status === 'REQUIRE_ACTION') {
                    await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
                    attempts++;
                } else {
                    break;
                }
            }
            const timeOut = redirectUrlRef?.current ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
            if (entity?.status === 'SUCCEEDED' || upiIndentCheckStatus.current === 'SUCCEEDED') {
                clearBookingHubSession();
                setTransactionSuccessModalOpen(true);
                setTimeout(handleRedirect, timeOut);
                return;
            } else if (entity?.status === 'REQUIRE_ACTION') {
                error({ data: { message: 'UPI payment could not be verified at the moment.' } });
            } else {
                error(response?.data?.message ? response : { data: { message: 'UPI Payment Failed' } });
            }
        } catch (e) {
            console.error('[short-poll] error:', e);
            error(e);
        } finally {
            paymentSessionGidRef.current = null;
            upiAppPsClientSecretRef.current = null;
            setTransactionModalOpen(false);
            dispatch(setIsWaitingForUpiApp(null));
            dispatch(setUserReturnedFromUpiApp(null));
            upiIndentCheckStatus.current = '';
        }
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
            paymentMethod.googlePayUS.binType = 'CREDIT';
        }
        const formattedPhoneNumber = formatToE164(
            data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
            data?.paymentMethodData?.info?.billingAddress?.countryCode
        );
        setRecaptchaPaymentType('cardPointGooglePay');
        await addCheckoutPageById({
            paymentMethod,
            customer: {
                name: data?.shippingAddress?.name || "",
                email: data?.email || "",
                phoneNumber: formattedPhoneNumber,
            }
        }, cardPointGooglePayToken);
    };

    const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
        try {
            paypalPaymentData.current = data;
            setTransactionModalOpen(true);
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
                    paymentMethod.googlePayUS.binType = 'CREDIT';
                }
                const formattedPhoneNumber = formatToE164(
                    data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
                    data?.paymentMethodData?.info?.billingAddress?.countryCode,
                    '+14485555555',
                );
                const responseEntity = await addCheckoutPageById({
                    paymentMethod,
                    customer: {
                        name: data?.shippingAddress?.name ?? data?.paymentMethodData?.info?.billingAddress?.name ?? 'anonymous user',
                        email: data?.email ?? 'anonymous@swirepay.com',
                        phoneNumber: formattedPhoneNumber,
                    }
                }, localRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                await action(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                await chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        } finally {
            setTransactionModalOpen(false);
        }
    };

    const chargeByApple = async (paymentData, recaptchaToken = null) => {
        const {
            deviceData,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        const billingAddress = { city, countryCode, state: stateCode, street };
        setRecaptchaPaymentType('paypalApplePay');
        const paymentMethod = {
            applePayUS: {
                deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4,
                binType: null,
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        };
        let customer = { email: customerEmail, name: customerName, phoneNumber: customerPhone };
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        const responseEntity = await addCheckoutPageById({
            paymentMethod,
            customerGid: getCustomerGidFromPayment(),
            customer,
        }, recaptchaToken);
        isPayPalApple.current = false;
        responseEntity.paymentSessionGid = responseEntity?.paymentSession?.gid;
        responseEntity.psClientSecret = responseEntity?.paymentSession?.psClientSecret;
        return responseEntity;
    };

    const chargeByApplePay = async (stripePaymentMethod, recaptchaToken = null) => {
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
            },
            customerGid: getCustomerGidFromPayment(),
            type: "WALLET",
            subType: "APPLE_PAY_US",
        };
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        const responseEntity = await addCheckoutPageById({ paymentMethod, customerGid: getCustomerGidFromPayment() }, recaptchaToken);
        return responseEntity;
    };

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const getCheckoutById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    clearBookingHubSession();
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(() => {
                        window.location = redirectionUri || SWIREPAY_URL;
                    }, timeOut);
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    clearBookingHubSession();
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(() => {
                        window.location = redirectionUri || SWIREPAY_URL;
                    }, timeOut);
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true, isOpen: true, hideBtn: false,
            cancel: resetAlertConfig,
            header: "Are you sure!",
            body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!",
            cancelBtnText: "Cancel",
            showCancelBtn: true, showSubmitBtn: true,
            submit: () => resetAlertConfig(),
            icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig);
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
                setPaymentLinkUpiGlobalRecaptcha(token);
                break;
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkGlobalRecaptcha(token);
                break;
            case 'paypalApplePay':
                setPaypalApplePayRecaptcha(token);
                setPaypalApplePayMessageModal(true);
                break;
            case 'paypalGooglePay':
                if (paypalPaymentData.current) {
                    chargeByPaypalGooglePay(paypalPaymentData.current, token);
                }
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await addCheckoutPageById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    };

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSession?.gid, orderDatas?.paymentSession?.psClientSecret);
            clearBookingHubSession();
            setTransactionSuccessModalOpen(true);
            chargeByIdSuccessActions(orderDatas);
        } catch (err) {
            console.error(err);
            throw err;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    let data = {};
                    const userAgent = {
                        acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
                        ip: ipAddress,
                        language: window.navigator.language,
                        colorDepth: window.screen.colorDepth,
                        screenHeight: window.screen.height,
                        screenWidth: window.screen.width,
                        timeZone: new Date().getTimezoneOffset(),
                        browserUserAgent: window.navigator.userAgent
                    };
                    let customer = {};
                    customer.email = payment?.bookingHubOrder?.customer?.email;
                    customer.phoneNumber = payment?.bookingHubOrder?.customer?.phoneNumber;
                    customer.name = payment?.bookingHubOrder?.customer?.name;
                    if (paypalData?.paymentSource === 'paypal') {
                        data = {
                            customer, userAgent, shouldWhatsAppNotify: false,
                            paymentMethod: {
                                payPalWallet: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET", subType: "PAYPAL_WALLET",
                            }
                        };
                    } else if (paypalData?.paymentSource === 'venmo') {
                        data = {
                            customer, userAgent, shouldWhatsAppNotify: false,
                            paymentMethod: {
                                venmo: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET", subType: "VENMO",
                            }
                        };
                    }
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    };
                    if (encriptedData?.keyId) {
                        const value = await addBookingHubOrderChargeById(bookingHubOrderLinkId, payload);
                        commonRecaptchaToken.current = null;
                        if (value?.paymentSession?.gid) {
                            setOrderData(value);
                            const orderData = await getWalletOrderInfo(value?.paymentSession?.gid, value?.paymentSession?.psClientSecret);
                            if (!orderData.id) {
                                const errorDetail = orderData.details?.[0];
                                const errorMessage = errorDetail
                                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                    : "Unexpected error occurred, please try again.";
                                throw new Error(errorMessage);
                            }
                            return orderData?.id;
                        }
                    }
                }
            }
        } catch (err) {
            if (err?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recaptcha Required');
            }
            console.error(err);
            throw err || new Error('Unexpected error occurred, please try again.');
        }
    };

    const chargeBySavedPaymentMethods = async (data) => {
        await addCheckoutPageById({
            paymentMethod: data,
            customer: {
                name: payment?.bookingHubOrder?.customer?.name,
                email: payment?.bookingHubOrder?.customer?.email,
                phoneNumber: payment?.bookingHubOrder?.customer?.phoneNumber,
            }
        });
    };

    const getCardNum = (cardNum) => {
        setUpdatedCardNum(cardNum);
    };

    const getCurrentTab = (tabName) => {};

    const updateSurcharge = (val) => {
        if (val === true || val === false) {
            setOptionalCheck(val);
        }
    };

    const uniquePaymentTypes = paymentTypeOrder
        ? paymentTypeOrder.map((res) => res ? res.category : null)
        : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';

    if (uniquePaymentTypes && uniquePaymentTypes.includes && uniquePaymentTypes.includes('APPLE_PAY_US')) {
        const index = uniquePaymentTypes.indexOf('APPLE_PAY_US');
        if (index > -1) uniquePaymentTypes.splice(index, 1);
    }

    const googlePaySplitUp = {
        spObjectType: "BOOKING_HUB_ORDER",
        spObjectGid: payment?.bookingHubOrder?.bookingHubGid,
        paymentType: "WALLET",
        subType: "GOOGLE_PAY_US",
        binType: "CREDIT"
    };

    const applePaySplitUp = {
        spObjectType: "BOOKING_HUB_ORDER",
        spObjectGid: payment?.bookingHubOrder?.bookingHubGid,
        paymentType: "WALLET",
        subType: "APPLE_PAY_US",
        binType: "CREDIT"
    };

    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.INSTANT_ACH) {
            children = <InstantAch
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.SWIFT_ACH) {
            children = <SwiftAch
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.RAPID_ACH) {
            children = <RapidWithPlaid
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.ZIP_ACH) {
            children = <ZipAchWithPlaid
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.X_ACH) {
            children = <XAchWithPlaid
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                amount={subTotal}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                headerText={accountGid?.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                payments={payment?.account?.gid}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={bookingHubOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />;
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={false}
                hideCustomer={false}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={customerInfo}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={payment?.account?.collectCustomerAddress}
                customerValidation={true}
                prefix={payment?.account?.currency?.prefix}
                billAmountApple={AmountDivideByHundred(payment?.bookingHubOrder?.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment?.bookingHubOrder?.total), payment?.account?.currency?.name)}`}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={payment?.account?.collectBillingAddress}
                isShippingAddressRequired={payment?.account?.collectShippingAddress}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                amount={subTotal}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={false}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                clearZipCode={true}
                charges={true}
                convenience={convenience}
                gst={gst}
                getPaymentCharges={getPaymentCharges}
            />;
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={false}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={customerInfo}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
            />;
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={false}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={customerInfo}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                upiUrl={`${BASE_URLS.BOOKING_HUB}/order-link/${bookingHubOrderLinkId}`}
                prefix={payment?.account?.currency?.prefix}
                alpha2={payment?.currency?.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                onReturnFromUpiApp={onReturnFromUpiApp}
                onChargeByUpiIndent={chargeByUpiIndent}
                acquirer={payment?.account?.acquirer}
            />;
            id = name;
        } else if (name === TabNames.CHALLAN) {
            children = <ChallanPayment
                showCancelBtn={false}
                hideCustomer={true}
                showBillDetails={true}
                cancel={null}
                errorMsg={errorMessage}
                upiError={null}
                errorHeader={null}
                customerReadOnly={false}
                submit={generateChallan}
                preFillCustomer={customerInfo}
                checkoutPageId={bookingHubOrderLinkId}
                headerText={"Pay With Challan"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                expireyText={null}
                count={null}
                prefix={payment?.account?.currency?.prefix}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment?.bookingHubOrder?.total), payment?.account?.currency?.name)}`}
                alpha2={payment?.account?.currency?.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                userType={userType}
                payments={payment}
                payment={payment}
                convenience={convenience}
                gst={gst}
                totalAmount={totalAmount}
            />;
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            splitUpPayload={googlePaySplitUp}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            preFillCustomer={payment?.bookingHubOrder?.customer}
                            chargeByGooglePay={chargeByGooglePay}
                            errorMsg={errorMessage}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                        />
                    )
                }
            </>;
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={false}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.BOOKING_HUB}/order-link/${bookingHubOrderLinkId}`}
                buttonText={submitBtnText}
                alpha2={payment?.currency?.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                preFillCustomer={customerInfo}
            />;
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={false}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                preFillCustomer={customerInfo}
                submit={chargeBySwirepayUS}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.BOOKING_HUB}/order-link/${bookingHubOrderLinkId}`}
                buttonText={submitBtnText}
                alpha2={payment?.currency?.countryAlpha2}
                swirepayUS={swirepayUS}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />;
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>;
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={false}
                hideCustomer={false}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={customerInfo}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={payment?.account?.collectCustomerAddress}
                customerValidation={true}
                prefix={payment?.account?.currency?.prefix}
                billAmountApple={AmountDivideByHundred(payment?.bookingHubOrder?.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment?.bookingHubOrder?.total), payment?.account?.currency?.name)}`}
                alpha2={payment?.account?.currency?.countryAlpha2}
                totalAmount={subTotal}
                userType={userType}
                payments={payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={payment?.account?.collectBillingAddress}
                isShippingAddressRequired={payment?.account?.collectShippingAddress}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                amount={subTotal}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={false}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                serviceFee={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                clearZipCode={true}
            />,
            id: 'CARD'
        }
    ];

    const tabPanelsApple = {
        children: <>
            {
                payPalClientAuth ? (
                    <ApplePayButton
                        recaptchaToken={paypalApplePayRecaptcha}
                        amount={payment?.bookingHubOrder?.total}
                        chargeByApple={chargeByApple}
                        payment={payment}
                        accountGid={payment?.account?.gid}
                        successCallback={chargeByIdSuccessActions}
                        failCallback={chargeByIdFailActions}
                        splitUpPayload={applePaySplitUp}
                        surchargeEnabled={payment?.account?.surchargeType !== 'NONE'}
                    />
                ) : (
                    <>
                        {
                            applePayment && isApplePay ? (
                                <Apple
                                    amount={payment?.bookingHubOrder?.total}
                                    chargeByApple={chargeByApple}
                                    payment={payment}
                                    splitUpPayload={applePaySplitUp}
                                    surchargeEnabled={false}
                                />
                            ) : null
                        }
                    </>
                )
            }
        </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    };

    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
        tabPanels.push({
            children: <SavedPaymentMethods
                buttonText={submitBtnText}
                submit={chargeBySavedPaymentMethods}
                supportedPaymentTypes={uniquePaymentTypes}
                surchargeEnabled={false}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                tip={finalTip}
                surcharge={surcharge}
                serviceFee={serviceFee}
                serviceFeeRate={serviceFeeRate}
                serviceFeeRateVal={serviceFeeRateVal}
                amount={subTotal}
                serviceFeeVal={feeService}
                discount={discount}
                subTotal={subTotalAfterDiscount}
                totalPayable={totalPayable}
                prefix={payment?.currency?.prefix}
                tax={finalTax}
                accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
            />,
            id: 'SAVED_PAYMENT_METHODS'
        });
    }

    if (payPalClientAuth && payPalClientId && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))) {
        tabPanels.push({
            children: <div style={{ width: '200px' }}>
                <PayPalCheckout
                    styles={{ shape: "rect", layout: "vertical" }}
                    createOrder={createOrder}
                    onApprove={onApprove}
                    payPalClientId={payPalClientId}
                    currency={payment?.account?.currency?.name || 'USD'}
                    country={payment?.account?.country?.alpha2 || 'US'}
                    accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                />
            </div>,
            id: 'PAYPAL_METHOD',
        });
        uniquePaymentTypes.push('PAYPAL_METHOD');
    }

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);

    const agregatorName = payment?.account?.aggregatorName;

    return (
        <BaseSplitPage
            errorHeader={null}
            errorMsg={errorMessage}
            left={
                <>
                    <FlexContainer
                        flexDirection="column"
                        position="relative"
                        display="block"
                        height="100%"
                    >
                        <div>
                            {
                                (payment?.account?.largeLogo) && (
                                    <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                                )
                            }
                            <H1Text>
                                Payment Checkout
                            </H1Text>
                            <div className="mb-2" style={{ fontWeight: '400', fontSize: '14px', color: '#909090' }}>
                                Payment For
                            </div>
                            <div style={{ fontWeight: '600', fontSize: '18px', color: '#1B1B1B' }}>
                                {payment?.description || payment?.account?.name}
                            </div>
                            <div className="mt-3 mb-3" style={{ fontWeight: '400', fontSize: '13px', color: '#474747' }}>
                                <p>
                                    Reference Id: {payment?.gid ? payment.gid.slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>}
                                </p>
                            </div>
                            {
                                tabName === 'UPI' && (
                                    <>
                                        <H2Text>Amount</H2Text>
                                        <DescriptionText fontSize="24px">
                                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.bookingHubOrder?.total), payment.account?.currency?.name)}` : null}
                                        </DescriptionText>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ position: "sticky", top: "85%" }}>
                            <Support
                                email={payment?.support?.email}
                                phone={payment?.support?.phone}
                                whiteLabel={payment?.account?.whiteLabel}
                                partnerImageUrl={partnerImageUrl}
                                bankImageUrl={bankImageUrl}
                            />
                        </div>
                    </FlexContainer>
                </>
            } right={
                <>
                    <Header
                        payment={payment}
                        bankImageUrl={bankImageUrl}
                        tabName={tabName}
                        cancelUrlLink={null}
                    />
                    {payment?.account?.country?.alpha2 === 'US' ? (
                        <PaymentExpandableRowsV2
                            id={bookingHubOrderLinkId}
                            paymentTypes={payment?.account?.currency?.countryAlpha2}
                            tabs={uniquePaymentTypes}
                            tabPanels={tabPanels}
                            defaultSelectedTab={selectedTab || 0}
                            onSelect={data => setSelectedTab(data)}
                            tabName={tabName}
                            upiDown={false}
                            applePayment={applePayment}
                            isApplePay={isApplePay}
                            accountGid={payment?.account?.gid}
                            getCurrentTab={getCurrentTab}
                            supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                            account={payment?.account}
                        />
                    ) : (
                        <PaymentExpandableRows
                            id={bookingHubOrderLinkId}
                            paymentTypes={payment?.account?.currency?.countryAlpha2}
                            tabs={uniquePaymentTypes}
                            tabPanels={tabPanels}
                            defaultSelectedTab={selectedTab || 0}
                            onSelect={data => setSelectedTab(data)}
                            tabName={tabName}
                            upiDown={false}
                            applePayment={applePayment}
                            isApplePay={isApplePay}
                            accountGid={payment?.account?.gid}
                            getCurrentTab={getCurrentTab}
                        />
                    )}
                    <SmallScreenFooter
                        partnerImageUrl={partnerImageUrl}
                        bankImageUrl={bankImageUrl}
                        whiteLabel={payment?.account?.whiteLabel}
                    />
                    <RecaptchaModal
                        visible={recaptchaModalVisible}
                        onVerified={onGlobalCaptchaVerified}
                    />
                    <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                    <SuccessModal isOpen={isTransactionSuccessModalOpen} manualPlaidPayment={manualPlaidPayment} />
                    <AlertModal
                        showIcon={alertConfig.showIcon}
                        isOpen={alertConfig.isOpen}
                        hideBtn={alertConfig.hideBtn}
                        cancel={alertConfig.cancel}
                        header={alertConfig.header}
                        body={alertConfig.body}
                        submitBtnText={alertConfig.submitBtnText}
                        cancelBtnText={alertConfig.cancelBtnText}
                        showCancelBtn={alertConfig.showCancelBtn}
                        showSubmitBtn={alertConfig.showSubmitBtn}
                        submit={alertConfig.submit}
                        icon={alertConfig.icon}
                    />
                    <Spinner isOpen={isShowSpinner} />
                </>
            } />
    );
};

export default BookingHubOrderPay;
